

import Gallery from '../modules/Gallery';
import ImageModule from '../modules/ProvenzaImage';
import SpaContenido from '../modules/SpaContenido';

export default function Convenios() {

    return (
        <div className='row'>
            <div><hr></hr></div>
            <SpaContenido />
         </div>

    )

}